import { useCallback } from 'react'
import { useDialogStore, type DialogState } from '../useDialogStore/useDialogStore'

export type SetDialogStateHookReturn<T> = (open: DialogState<T>['open'], data?: DialogState<T>['data']) => void

export const useSetDialogState = <T>(id: string): SetDialogStateHookReturn<T> => {
  const setState = useDialogStore(({ setState }) => setState)

  return useCallback(
    (open, data) => {
      setState(id, open, data)
    },
    [id, setState],
  )
}
